












import {Component, Prop, Vue} from 'vue-property-decorator'
import BusinessCondition from '@/domain/BusinessCondition'
import {PortfolioSituation} from '@/domain/PortfolioSituation'

@Component
export default class ConditionList extends Vue {
  @Prop()
  public selectedCondition?: BusinessCondition | undefined = undefined
  @Prop()
  public situations: PortfolioSituation[] | undefined

  public bcs = BusinessCondition.all()

  private selectCondition(bc: BusinessCondition) {
    this.$emit('select', bc)
  }

  private active(code: string): boolean {
    if (!this.selectedCondition) {
      return false
    }
    return this.selectedCondition.code === code
  }

  private getRatioHeight(code: string): number {
    if (!this.situations || this.situations.length === 0) {
      return 0
    }
    return this.situations
        .find((v) => v && v.situationCode === code)
        ?.ratio ?? 0
  }
}
